<script lang="ts" setup>
import { useField } from "vee-validate";
//@ts-ignore
import BaseInput from "@/components/form/_base.vue";
import Multiselect from "@vueform/multiselect";

interface Props {
    name: string;
    label: string;
    placeholder: string;
    options: Array<{ id: number | string; name: string }>;
    inputClass: string;
    mode: "single" | "tags";
    hideBox?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    name: undefined,
    label: undefined,
    placeholder: undefined,
    inputClass: "md",
    mode: "tags",
    hideBox: false,
});

const { value, handleChange, handleBlur, errorMessage, meta } = useField(props.name);
const mode = typeof value.value === "string" ? "single" : props.mode;
const delayedBlur = () => setTimeout(handleBlur, 500);
</script>

<template>
    <BaseInput :errorMessage="errorMessage" :meta="meta" :name="name" :label="label" class="relative">
        <Multiselect :class="[inputClass, { '': label !== '' }]" v-model="value" @change="handleChange" @close="delayedBlur" :name="name" :mode="mode" searchable="true" valueProp="id" trackBy="name" :max-height="100" label="name" :placeholder="placeholder" :options="options" />
        <div v-if="hideBox" class="absolute right-[16px] top-[15px] h-[14px] w-[14px] rounded-[2px] border-2 border-[#0000003D] block z-10"></div>
    </BaseInput>
</template>
